import { get } from "~/api2/utils/requests"
import { IElectricPrice } from "~/types/ElectricPrice"

const API_ELECTRIC_PRICES = "/electric_prices"

const fetchElectricPrices = async (campId: string): Promise<{ electric_prices: Array<IElectricPrice> }> => {
  if (!campId) {
    throw new Error("Camp ID is required")
  }

  return await get(`/api/camps/${campId}${API_ELECTRIC_PRICES}`).catch((error) => {
    console.error("Failed to fetch electric prices:", error)
    throw error
  })
}

const ElectricPrices = {
  fetchElectricPrices,
}

export default ElectricPrices
